jQuery(document).ready(function ($) {


    if( $('.title-container').length > 0) {

        $('.title-container').on('click', function(){
            if( $('#kuFilters').hasClass('expanded') ){
                $('#kuFilters').removeClass('expanded');
                $(this).removeClass('active');

            } else {
                $('#kuFilters').addClass('expanded');
                $(this).addClass('active');
            }
        });
    }


    function general_resp(){


        function setupreset(){
            setTimeout(function(){
                if( $('#ssw-edit-profile-form').length > 0 ){
                    console.log('test');
                    $('#ssw-edit-profile-social').parent().append('<div class="reset password."><div class="style-two">To reset your password, <a href="javascript:void(0)" onclick="openForgotLightbox();" class="centered-text red-color">click this link and follow the steps.</a></div></div>');
                }
            }, 500);
        }
        setupreset();


        function dropdown_lines(){
            // console.log('header lines');
            $('.dropdown-menu').each(function(){  
              
                var highestBox = 0;
                $('.col.col-2').each(function(){

                    if($(this).height() > highestBox) {
                        highestBox = $(this).height(); 
                    }
                  
                });  
                        
                $('.col.col-2',this).height(highestBox);
            });
        }
        dropdown_lines();

        function setDropdown(){
            $('.dropdown-menu').css('width', $('#global-nav').width());
            $('.dropdown-menu').css('left', ( $(window).width() - $('#global-nav').width())/2 );
        }
        setDropdown();

        function tablet_nav_fix(){
            if( $(window).width() < 1100){
                $('#global-nav > ul > li > a').attr('href', 'javascript:void(0);');
            }
        }
        tablet_nav_fix();
    }

    function general(){


        $('.buy-it-again-qtr').on('change', function(){
            console.log($(this).val());
            var the_qty = $(this).val(),
                a_select = $(this).parent().find('a.lh-button'),
                a_select__data_url_1 = a_select.attr('data-url-1');

            $(this).parent().find('a.lh-button').attr('data-url-2', the_qty);
            a_select.attr('href', a_select__data_url_1+the_qty);
        });

        $('.cart-item--remove-link').on('click', function(){
            setTimeout(function(){
                if( $('.cartitems article').length == 0){
                    $('.cartitems-empty.ajax').removeClass('hide');
                }
            },500);

            setTimeout(function(){
                if( $('.cartitems article').length == 0){
                    $('.cartitems-empty.ajax').removeClass('hide');
                }
            },2000);
        });

        $('.global-nav-item').on('hover mouseenter', function(){
            var activeSlug = $(this).data('name');

            $('.dropdown-menu').removeClass('active');
            $('#'+activeSlug).addClass('active');
        });

        $('.site-main, #middle-section, #top-section').on('hover mouseenter', function(){
            $('.dropdown-menu').removeClass('active');
        });

        //live chat
        $('#livechat-button').bind('click', function(){
            $('#livechat-body').toggleClass('active');
            $('#livechat').toggleClass('active');
        });

        $('#livechat-init').on('click', function(){
            $('#SnapABug_bImg').trigger('click');
        });

        $('#close-livechat').on('click', function(){
            $('#livechat').removeClass('active');
            $('#livechat-body').removeClass('active');
        });
        
    
        function centerNewsletter(){
            if( $('.popup-modal').length > 0 ){
                // $('.popup-modal').css('margin-left', -($('.popup-modal').width()/2) );
                $('.popup-modal').css('margin-top', -($('.popup-modal').height()/2) );
            }
        }
        centerNewsletter();

        $('#get-bulk-quote').on('click', function(){
            centerNewsletter();
            $('body').addClass('active-popup');
            $('.popup-modal, .popup-modal-overlay').removeClass('hide').fadeIn(300);
        });

        function removeLightBox_newsletter(){
            $('.popup-modal, .popup-modal-overlay, .sku-outofstock-lightbox-container').fadeOut(300);
            $('body').removeClass('active-popup');
        }

        $('.close-popup, .popup-modal-overlay').bind('click', function(){
            removeLightBox_newsletter();
            // parent.location.hash = '';
        });

        // if( window.location.hash == '#contact_form'){
        //   centerNewsletter();

        //   $('.popup-modal, .popup-modal-overlay').removeClass('hide').fadeIn(300);
        // }
        
        //mobile Button
        var mobileNavFlag = false;
        $(document).find('#mobile-nav-button').on('click', function(e){
            e.preventDefault();   
            
            if( mobileNavFlag == false){
                $(this).addClass('active-mobile-nav-button');
                $('body').addClass('mobile-nav-active-body');
                $('#mobile-global-nav').addClass('active-mobile-nav');
                $('#global-header').addClass('active-mobile-nav');
                $('html').addClass('has-fullscreen-item');

                mobileNavFlag = true;               
                e.stopPropagation();  
            } else {
                $(this).removeClass('active-mobile-nav-button');
                $('body').removeClass('mobile-nav-active-body');
                $('#mobile-global-nav').removeClass('active-mobile-nav');
                $('#global-header').removeClass('active-mobile-nav');
                $('html').removeClass('has-fullscreen-item');

                mobileNavFlag = false;              
                e.stopPropagation();                 
            } 
        });

        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                
                if( $('#mobile-global-nav').hasClass('active-mobile-nav')){
                    $('#mobile-nav-button').removeClass('active-mobile-nav-button');
                    $('body').removeClass('mobile-nav-active-body');
                    $('#mobile-global-nav').removeClass('active-mobile-nav');
                    $('#global-header').removeClass('active-mobile-nav');
                    $('html').removeClass('has-fullscreen-item');
                    $('body').removeClass('has-popup');

                    mobileNavFlag = false;              
                }

                if( $('.popup-modal').css('display') == "block") {
                    removeLightBox_newsletter();
                    parent.location.hash = '';
                }

              if( $('#free-ship-div').css('display') == "block") {
                $('#overlay').fadeOut('fast');
                $('#free-ship-div').hide();
              }

              if( $('#freeship-nomin-div').css('display') == "block") {
                $('#overlay').fadeOut('fast');
                $('#freeship-nomin-div').hide();
              }

              if( $('#want-tomo-div').css('display') == "block") {
                $('#overlay').fadeOut('fast');
                $('#want-tomo-div').hide();
              }
            }
        });



        $('.hover-init').on('mouseenter', function() {
            $(this).next().fadeIn();
        });

        $('.clearfix, .shopify-section product--section').on('mouseenter', function() {
            $('.popup-hover').fadeOut();
        });

        $('#product-container .half-column .rewards-product-view-points').on('hover', function() {
            $('.popup-hover').fadeOut();
        });

        $('.sidebar-section .show').on('click', function(){
            $(this).parents('.sidebar-section').addClass('active');
        });

        $('.sidebar-section .hideit').on('click', function(){
            $(this).parents('.sidebar-section').removeClass('active');
        });



        if( $('.sidebar').length > 0){

            $('.title-container').on('click', function(){
                if( $('#sidebar-container').hasClass('expanded') ){
                    $('#sidebar-container').removeClass('expanded');
                    $(this).removeClass('active');

                } else {
                    $('#sidebar-container').addClass('expanded');
                    $(this).addClass('active');
                }
            });
        }

        $('.remove-product-from-cart').on('click', function(){
            $(this).parents('tr').find('.cart-item-quantity input').val('1');
            $(this).parents('tr').find('.cart-item-quantity .cart-item-decrease').trigger('click');
        });

        $(document).find('.more').on('click', function(){
            $('.level-1.hide').removeClass('hide');
            $('.more').addClass('hide');
        });

    };



    function init_slick(){
        if( $('.init-slick-slider').length > 0 ) {
            $('.init-slick-slider').slick({
                dots: true,
                infinite: true,
                speed: 800,
                autoplaySpeed: 4000,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: false,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }
    }

    function init_slick_carousel(){
        if( $('.init-slick-carousel').length > 0 ) {
            $('.init-slick-carousel').slick({
                dots: false,
                infinite: true,
                speed: 800,
                autoplaySpeed: 1800,
                draggable: true,

                slidesToShow: 7,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: true,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 1100,
                    arrows: false, 
                    settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }
    }

    function relatedProducts_slider(){
        if( $('#related-products').length > 0 ) {
            $('#related-products').slick({
                dots: false,
                infinite: true,
                speed: 800,
                autoplaySpeed: 1800,
                draggable: true,

                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: true,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  }
                ]
            });

            function related_boxes(){
                // $('#productgrid--item').each(function(){  
                    var highestBox = 0;
                    $('#related-products .productgrid--item .inner').each(function(){

                        if($(this).height() > highestBox) {
                            highestBox = $(this).height(); 
                        }
                      
                    });  
                            
                    $('#related-products .productgrid--item .inner').height(highestBox);
                // });
            }
            related_boxes();
        }
    }


                

                


    function brands_master_list(){
        if( $('#brands-master-list').length > 0 ) {
            $('#brands-master-list:not(.slick-initialized)').slick({
                dots: false,
                infinite: true,
                speed: 800,
                autoplaySpeed: 1800,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: true,

                asNavFor: '#brands-nav',
                easing: 'easeOutCubic',
                autoplay: false,
                arrows: false,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }

        $('#brands-nav:not(.slick-initialized)').slick({
            slidesToShow: 300,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '#brands-master-list',
            dots: false,
            centerMode: false,
            focusOnSelect: true
        });
    }

    function slickinit(){

        if( $('.slick-initt').length > 0 ) {
            $('.slick-initt').slick({
                dots: false,
                infinite: true,
                speed: 800,
                autoplaySpeed: 3500,
                draggable: false,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: true,

                easing: 'easeOutCubic',
                autoplay: false,
                arrows: false,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }

        if( $('.slick-initt-arrow').length > 0 ) {
            $('.slick-initt-arrow')
              .on('init', function(event, slick, currentSlide, nextSlide) {
                    console.log('init'); 
                    if( $(window).width() > 480) {
                        $('.the-slide .zoomit').zoom();
                    } else {
                        $('.the-slide .zoomit').trigger('zoom.destroy').removeClass('zoomit');
                        $('.zoomImg').removeClass('zoomImg');
                        $('.product-slide').unwrap();
                    }
              })
              .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    // console.log('beforeChange'); 
                    // $('.the-slide .zoomit').trigger('zoom.destroy');
              })
              .on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    // console.log('afterChange'); 
                    // $('.the-slide.slick-current .zoomit').zoom();
              })
              .slick({
                dots: false,
                infinite: false,
                speed: 800,
                autoplaySpeed: 3500,
                draggable: false,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: true,

                easing: 'easeOutCubic',
                autoplay: false,
                arrows: true,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"><svg width="13px" height="26px" viewBox="0 0 13 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Large-Display" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Homepage-Copy" transform="translate(-234.000000, -1382.000000)" stroke="#000000"><polyline id="Line-3-Copy-2" transform="translate(240.500000, 1395.000000) scale(-1, 1) rotate(-90.000000) translate(-240.500000, -1395.000000) " points="228.5 1388.5 240.438279 1401.5 252.5 1388.5"></polyline></g></g></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="13px" height="26px" viewBox="0 0 13 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Large-Display" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Homepage-Copy" transform="translate(-1550.000000, -1382.000000)" stroke="#000000"><polyline id="Line-3-Copy-2" transform="translate(1556.500000, 1395.000000) rotate(-90.000000) translate(-1556.500000, -1395.000000) " points="1544.5 1388.5 1556.43828 1401.5 1568.5 1388.5"></polyline></g></g></svg> </button>',
                asNavFor: '.slick-initt-thumbs',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            })

            if( $('.slick-initt-thumbs').length > 0 ){
                $('.slick-initt-thumbs').slick({
                    // $('#single-portfolio-slider-184-nav-exhibit .inner').slick({
                        slidesToShow: 300,
                        slidesToScroll: 1,
                        infinite: false,
                        asNavFor: '.slick-initt-arrow',
                        dots: false,
                        centerMode: false,
                        focusOnSelect: true
                    }).on('reInit', function(event, slick, currentSlide, nextSlide) {
                        console.log('REinit'); 
                  });
            }
        }

    };

    


    $(window).ready(function(){
        general();
        general_resp();
        init_slick();
        init_slick_carousel();
        brands_master_list();
        relatedProducts_slider();
        slickinit();
    });


    $(window).resize(function(){
       general_resp();
    });
});     
/* ------------------------------------------------------------------
 * Carousel accessibility: normalise slider ARIA to a labelled group of
 * slides, and keep off-screen slides out of both the accessibility tree
 * and the tab order. Re-applied on slider events because slide changes
 * rewrite aria-hidden and tabindex.
 * ------------------------------------------------------------------ */
(function ($) {
  if (!$) return;

  function fixSlickA11y(el) {
    var $s = $(el);
    if (!$s.length || !$s.hasClass('slick-initialized')) return;

    $s.attr('role', 'group');
    $s.attr('aria-roledescription', 'carousel');
    if (!$s.attr('aria-label') && !$s.attr('aria-labelledby')) {
      $s.attr('aria-label', 'Featured promotions');
    }

    // slick's listbox/tablist scaffolding is not valid here.
    $s.find('.slick-list, .slick-track').removeAttr('role');

    $s.find('.slick-slide').each(function () {
      var $slide = $(this);
      $slide.removeAttr('role').removeAttr('aria-describedby');
      $slide.attr('aria-roledescription', 'slide');

      var hidden = $slide.attr('aria-hidden') === 'true';
      $slide.find('a, button, input, select, textarea, iframe, [tabindex]').each(function () {
        if (hidden) {
          this.setAttribute('tabindex', '-1');
        } else if (this.getAttribute('tabindex') === '-1') {
          this.removeAttribute('tabindex');
        }
      });
    });

    var $dots = $s.find('.slick-dots');
    if ($dots.length) {
      $dots.removeAttr('role');
      $dots.children('li').each(function (i) {
        var $li = $(this);
        // Express the active dot with aria-current on the button, and drop
        // attributes that are not valid on a roleless <li>.
        $li.removeAttr('role')
           .removeAttr('aria-selected')
           .removeAttr('aria-controls')
           .removeAttr('aria-hidden');
        $li.children('button')
          .removeAttr('role')
          .removeAttr('aria-describedby')
          .removeAttr('aria-controls')
          .attr('aria-label', 'Go to slide ' + (i + 1))
          .attr('aria-current', $li.hasClass('slick-active') ? 'true' : 'false');
      });
    }
  }

  function sweep() {
    $('.slick-initialized').each(function () { fixSlickA11y(this); });
  }

  // slick fires these on the slider element; re-apply because slick rewrites
  // aria-hidden and tabindex on every slide change.
  $(document).on('init reInit afterChange setPosition breakpoint', '.slick-slider', function () {
    fixSlickA11y(this);
  });

  $(function () {
    sweep();
    // Some sliders initialise after DOM ready (images, breakpoints, late JS).
    var n = 0;
    var t = setInterval(function () { sweep(); if (++n > 20) clearInterval(t); }, 300);
  });
})(window.jQuery);
